import React, { useCallback, memo } from "react";
import { useMainContext } from "../../../store/Context";
import "./SideMenuSelection.style.scss";
import { FormattedMessage } from "react-intl";
import { useSideMenu } from "../../sideMenu.context";
import CurrencyFormat from "../../../services/CurrencyService";

const PRODUCT_TYPE = {
  strap: "strap",
  dice: "dice",
};

const Product = memo(({ item, type, onPressRemove }) => {
  return (
    <div
      className={`SideMenuSelection-Product ${
        type === PRODUCT_TYPE.strap ? "SideMenuSelection-Product-Strap" : ""
      }`}
    >
      <div className="SideMenuSelection-Product-Image">
        <div>
          <img
            src={item.images[0].image0 || item.images[0]}
            alt="selection product"
          />
        </div>
      </div>
      <div className="SideMenuSelection-Product-Details">
        <p>{item.title}</p>
        <label>
          <FormattedMessage id="Dialog.material" />: {item.material}
        </label>
        <label>
          <FormattedMessage id="Dialog.size" />: {item.size}
        </label>
        <label>
          <FormattedMessage id="Dialog.color" />: {item.color}
        </label>
        <label>
          <FormattedMessage id="Dialog.cil" />: {item.id}
        </label>
      </div>
      <div className="SideMenuSelection-Product-Price">
        {CurrencyFormat.calculateFormat(item.price)}
        {onPressRemove && (
          <div
            className="SideMenuSelection-Product-Delete"
            onClick={onPressRemove}
          >
            Eliminar
          </div>
        )}
      </div>
    </div>
  );
});

const SideMenuSelection = () => {
  const { product, getTotal, getProductsIds, removeDice } = useMainContext();
  const { setOpen } = useSideMenu();

  const handlerButton = () => {
    setOpen(false);
    window &&
      window.dataLayer &&
      window.dataLayer.push({ event: "orderClick" });
  };

  const onPressRemove = useCallback((index) => {
    removeDice(index);
  }, []);

  return (
    <div className="SideMenuSelection">
      <div className="SideMenuSelection-Title">
        <FormattedMessage id="Product.viewAction" />
      </div>
      <div className="SideMenuSelection-Content">
        {product.strap && (
          <Product item={product.strap} type={PRODUCT_TYPE.strap} />
        )}
        {product.dices
          .filter((dice) => dice.id)
          .map((dice, index) => (
            <Product
              key={index}
              item={dice}
              type={PRODUCT_TYPE.dice}
              onPressRemove={() => onPressRemove(index + 1)}
            />
          ))}
      </div>
      <div className="SideMenuSelection-Footer">
        <div className="SideMenuSelection-Footer-Total">
          <label>
            <FormattedMessage id="App.subtotal" />
          </label>
          <label>{getTotal()}</label>
        </div>
        <button
          data-add-product-ids={getProductsIds()}
          className="SideMenuSelection-Footer-Add"
          onClick={handlerButton}
        >
          <FormattedMessage id="Product.button" />
        </button>
      </div>
    </div>
  );
};

export default memo(SideMenuSelection);
